import { useRouteError, isRouteErrorResponse, Link } from "react-router-dom"
import { AlertTriangle } from "lucide-react"

export function RouteErrorPage() {
  const error = useRouteError()

  let title = "Something went wrong"
  let message = "An unexpected error occurred."

  if (isRouteErrorResponse(error)) {
    title = `${error.status} ${error.statusText}`
    message = error.data?.message || "The page you're looking for doesn't exist."
  } else if (error instanceof Error) {
    message = error.message
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background p-8">
      <AlertTriangle className="size-12 text-destructive" />
      <h1 className="text-2xl font-bold">{title}</h1>
      <p className="max-w-md text-center text-sm text-muted-foreground">
        {message}
      </p>
      <Link
        to="/"
        className="rounded-md bg-primary px-4 py-2 text-sm text-primary-foreground hover:bg-primary/90"
      >
        Back to Dashboard
      </Link>
    </div>
  )
}
